import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { AdminUser, AdminUserPost } from 'src/types/shared/AdminUser';

export const createAdminUserRequest = createAction('createAdminUserRequest');
export const createAdminUserSuccess = createAction<AdminUserPost>('createAdminUserSuccess');
export const createAdminUserFailure = createAction('createAdminUserFailure');

export const createAdminUser = (postbody: AdminUserPost) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(createAdminUserRequest());
    try {
        const { data }: CreateUserResponse = await api.post(`admin/admins`, postbody);

        dispatch(createAdminUserSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, createAdminUserFailure, e);
    }
};

interface CreateUserResponse {
    data: AdminUser;
}
